export function collectDeviceNamesFromReportsData(reportsData = []) {
  const names = new Set();

  reportsData.forEach((entry) => {
    (entry.deviceStatus || []).forEach((status) => {
      if (status?.deviceName) {
        names.add(status.deviceName);
      }
    });

    (entry.trips || []).forEach((group) => {
      (group.trips || []).forEach((trip) => {
        if (trip?.deviceName) {
          names.add(trip.deviceName);
        }
      });
      if (group?.deviceName) {
        names.add(group.deviceName);
      }
    });

    (entry.zoneActivities || []).forEach((group) => {
      (group.zoneActivities || []).forEach((activity) => {
        if (activity?.deviceName) {
          names.add(activity.deviceName);
        }
      });
    });
  });

  return Array.from(names);
}

export function resolveDeviceNames(deviceIds = [], reportsData = [], deviceNameById = {}) {
  const fromActivity = collectDeviceNamesFromReportsData(reportsData);
  if (fromActivity.length) {
    return fromActivity;
  }

  const fromIds = (deviceIds || [])
    .map((id) => deviceNameById[id] || deviceNameById[String(id)])
    .filter(Boolean);

  return [...new Set(fromIds)];
}

export function formatDeviceNamesList(names = [], maxVisible = 3) {
  if (!names.length) {
    return '—';
  }
  if (names.length <= maxVisible) {
    return names.join(', ');
  }
  return `${names.slice(0, maxVisible).join(', ')} +${names.length - maxVisible} more`;
}

export function buildDeviceNameMap(devices = []) {
  return devices.reduce((map, device) => {
    if (device?._id && device?.name) {
      map[device._id] = device.name;
    }
    return map;
  }, {});
}
